import React, { Component } from 'react';
import Powerbi from '../components/Powerbi';
import { Helmet } from 'react-helmet';
import * as pbi from 'powerbi-client';
import { connect } from 'react-redux';
import { requestPMDInternalMonthlyReport, requestExportToPDF } from "../../../store/power-bi/PowerBiActions";
import { hostTitle } from '../../../config/ui';

class PMDInternalMonthlyReport extends Component {
  componentWillMount() {
    this.props.getPMDInternalMonthlyReport();
  };

  exportToPDFclick = (reportId, reportName) => {
    this.props.exportToPDF(reportId)
      .then((response) => {
        const blob = response.payload;
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = reportName +'.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
      });
  };

  render() {
    const models = pbi.models;
    const data = this.props.reports.pmdInternalMonthly;

    return (
      <div id="reportContainer">
        <Helmet title={`PMD Internal Clinic Dashboard - Monthly – ${hostTitle()}`} />
        <button
          className="btn btn-primary btn-xs"
          onClick={() => this.exportToPDFclick(data.id, data.reportName)}>
          Export To PDF
        </button>
        {data.accessToken &&
          <Powerbi
            id={data.id}
            embedUrl={data.embedUrl}
            accessToken={data.accessToken}
            tokenType={models.TokenType.Embed}
            filterPaneEnabled={true}
            navContentPaneEnabled={true}
            width='100%'
            height='600px'
          />
        }
      </div>
    )
  }
}

//export default App
export default connect(
  state => state.powerbi,
  dispatch => ({
    getPMDInternalMonthlyReport: () => dispatch(requestPMDInternalMonthlyReport()),
    exportToPDF: (reportId) => dispatch(requestExportToPDF(reportId)),
  }),
)(PMDInternalMonthlyReport);




// WEBPACK FOOTER //
// ./src/routes/reports-analytics/containers/PMDInternalMonthlyReport.js